<template>
	<div :style="{'border-color': $vuetify.theme.dark ? '' : '#E0E0E0 !important'}" class="taskboard-task background-2" @click.stop="editTask()" :id="task.id">
		<div  v-if="task.img">
			<img>
		</div>

		<div class="tasklist-task-details">
<!-- 			<div class="list-card-sort-handle">
				<mat-icon class="icon s16 mat-icon material-icons" mat-font-icon="icon-cursor-move" role="img" aria-hidden="true">
				</mat-icon>
			</div> -->
			<!-- <div class="tasklist-task-labels" style="display: flex;">
				<span class="tasklist-task-label orange-400">
				</span>
				<span class="tasklist-task-label blue-600">
				</span>
			</div> -->
			<div class="tasklist-task-name" style="display: flex">
				<div class="w100p">{{ task.title }}</div>
					<v-overlay v-if="selectsMode"
					absolute
					:opacity="0.1"
					:z-index="5">
				<v-checkbox style="margin-top: 0px; padding-top: 0px;" hide-details color="primary" v-if="selectsMode" v-model="task.selected"></v-checkbox>
			</v-overlay>
			</div>
			<div class="tasklist-task-badges" style="display: flex;">
				<v-chip v-if="task.created_by_portal" x-small color="blue" dark label class="mr-1" title="Segnalazione dal portale cliente">
					<v-icon x-small left>mdi-account</v-icon>Cliente
				</v-chip>
				<v-chip v-if="task.portal_confirmed_at" x-small color="green" dark label class="mr-1" title="Risoluzione confermata dal cliente">
					<v-icon x-small left>mdi-check-decagram</v-icon>Confermato
				</v-chip>
				<span class="badge" :class="checkExpirationDate" style="display: flex;" v-if="formatExpirationDate">
					<v-icon style="color: inherit; font-size: 16px !important; margin: auto;">schedule</v-icon>
					<span class="capitalize fs12" style="margin: auto">&nbsp; {{ formatExpirationDate }}</span>
				</span>
				<template v-if="!$store.getters.checkSettings('hide_checklists_task')">
					<span class="badge check-items fs12" style="display: flex;" v-if="task.checklists.length > 0">
						<v-icon color="white" style="font-size: 16px !important; margin: auto;">check</v-icon>
						<span>&nbsp; {{ completedItems }}</span>
						<span>/</span>
						<span> {{ lengthItems }}</span>
					</span>
				</template>
			</div>

			<div class="taslist-task-members" style="flex-direction: row; box-sizing: border-box; display: flex;">
				<div class="tasklist-card-member">
					<div class="v-avatar" style="height: 34px; width: 36px;" v-for="(user, u) in task.users" :key="u">
						<template v-if="user.name == undefined">
							<div v-if="$store.getters.avatars[user.value]" class="v-avatar custom-avatar" :style="'height: 30px; width: 30px; background-image: url('+$store.getters.avatars[user.value]+')'"></div>
							<v-avatar v-else :class="$eventBusUtility.bgColor(user.value)" :size="30">
								<span class="white--text fs14">{{ user.text ? user.text.charAt(0) : '' }}</span>
							</v-avatar>
						</template>
						<template v-else>
							<div v-if="$store.getters.avatars[user.id]" class="v-avatar custom-avatar" :style="'height: 30px; width: 30px; background-image: url('+$store.getters.avatars[user.id]+')'"></div>
							<v-avatar v-else :class="$eventBusUtility.bgColor(user.id)" :size="30">
								<span class="white--text fs14">{{ user.name ? user.name.charAt(0) : '' }}</span>
							</v-avatar>
						</template>
					</div>
				</div>
			</div>
		</div>

		<div class="list-card-footer" style="display: flex; place-content: center space-between;">
			<div style="display: flex">
				<span class="v-v-list-item__action-text fs11i grey--text" style="margin: auto">
                    {{ task.creator }} - {{ task.created_at | date }}
                </span>
			</div>
			<div style="display: flex;">
				<!-- <span class="list-card-footer-item" style="display: flex; align-items: center;">
					<v-icon color="grey">attachment</v-icon>
					<span class="value">2</span>
				</span>
				<span class="list-card-footer-item" style="display: flex; align-items: center;">
					<v-icon color="grey">comment</v-icon>
					<span class="value">2</span>
				</span> -->
				<span class="list-card-footer-item" style="display: flex; align-items: center;">
					<v-avatar :class="$eventBusUtility.priorityColor(task.priority)" :size="24">
						<span class="white--text fs12 capitalize">{{ task.priority }}</span>
					</v-avatar>
				</span>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'task',
	props: {
		task: Object,
		selectsMode: Boolean,
	},

	watch: {
		'task.selected'(newVal, oldVal) {
			if(newVal == true) {
				this.$eventBusUtility.$emit('selectTask', this.task.id)
			} else if(newVal == false) {
				this.$eventBusUtility.$emit('unSelectTask', this.task.id)
			} 
		},
	},

	computed: {
		formatExpirationDate() {
			if(this.task.expiration_date) {
				return moment(this.task.expiration_date).format('D MMM, Y')
			} else {
				return false
			}
		},

		checkExpirationDate() {
			if(this.task.expiration_date) {
				if(moment(this.task.expiration_date).isAfter()) {
					return 'task-not-expired'
				} else {
					return 'task-expired'
				}
			} else {
				return 'no-expiration-date'
			}
		},

		completedItems() {
			let completed = 0
			_.forEach(this.task.checklists, (checklist) => {
				if(checklist.checklistitems && checklist.checklistitems.length > 0) {
					completed += checklist.checklistitems.filter(item => item.done).length
				}
			}) 
			return completed
		},
			  
		progressItems() {
			if(this.task.checklists.checklistitems) {
				return this.completedItems / this.task.checklists.checklistitems.length * 100
			} else {
				return 0
			}
				
		},
			  
		lengthItems() {
			let items_length = 0
			_.forEach(this.task.checklists, (checklist) => {
				if(checklist.checklistitems && checklist.checklistitems.length > 0) {
					items_length += checklist.checklistitems.length
				}
			}) 
			return items_length
      	},
	},

	methods: {
		editTask() {
			if(!this.selectsMode) {
				this.$eventBusUtility.$emit('editTask', {
					task: Object.assign({}, this.task),
				showDialog: true,
				})
			}
		},
	},
}
</script>
<style>
	.task-not-expired {
		background-color: #4caf50 !important;
	}
	.task-expired {
		background-color: #f44336 !important;
	}
	.no-expiration-date {
	    background-color: #fff !important;
		color: #64B5F6 !important;
		border: 1px solid #64B5F6;
	}
	.taskboard-task {
	    background-color: #fff;
	    border-color: rgba(0,0,0,.12) !important;
	}
	.taskboard-task {
	    position: relative;
	    display: block;
	    width: 100%;
	    margin: 16px 0!important;
	    border-radius: 4px;
	    border: 1px solid;
	    cursor: pointer;
	}

	.taskboard-task:hover {
		opacity: 0.6;
	}

	.taskboard-task .tasklist-task-details {
	    padding: 16px 16px 0;
	}
	.taskboard-task .tasklist-task-details .tasklist-task-labels {
	    margin-bottom: 6px;
	}
	.taskboard-task .tasklist-task-details .tasklist-task-labels .tasklist-task-label {
	    width: 32px;
	    height: 6px;
	    border-radius: 6px;
	    margin: 0 6px 6px 0;
	}
	.orange-400 {
	    background-color: #ffa726!important;
	    color: rgba(0,0,0,.87)!important;
	}
	.blue-600 {
	    background-color: #1e88e5!important;
	    color: #fff!important;
	}
	.taskboard-task .tasklist-task-details .tasklist-task-name {
	    font-size: 14px;
	    font-weight: 600;
	    margin-bottom: 12px;
	}
	.taskboard-task .tasklist-task-details .tasklist-task-badges {
	}
	.taskboard-task .tasklist-task-details .tasklist-task-badges .badge.due-date.overdue {
	    background-color: #f44336;
	}
	.taskboard-task .tasklist-task-details .tasklist-task-badges .badge.due-date {
	    background-color: #4caf50;
	}
	.taskboard-task .tasklist-task-details .tasklist-task-badges .badge {
	    margin-right: 8px;
	    padding: 4px 8px;
	    border-radius: 2px;
	}
	.taskboard-task .tasklist-task-details .tasklist-task-badges .badge {
	    background-color: #B0BEC5;
	    color: #fff;
	    margin-right: 8px;
	    padding: 4px 8px;
	    border-radius: 4px;
	}

	/* CUSTOM */
	.tasklist-task-badges .v-icon {
		font-size: 18px !important
	}
	/**/
	.taskboard-task .tasklist-task-details .taslist-task-members {
	    margin-bottom: 12px;
	    margin-top: 12px;
	}
	.taskboard-task .tasklist-task-details .taslist-task-members .tasklist-card-member {
	    margin-right: 8px;
	}
	.taskboard-task .tasklist-task-details .taslist-task-members .tasklist-card-member .tasklist-card-member-avatar {
	    border-radius: 50%;
	    width: 32px;
	    height: 32px;
	}
	img {
	    max-width: 100%;
	    height: auto;
	    vertical-align: top;
	    border: none;
	}
	.taskboard-task .list-card-footer {
	    border-top-color: rgba(0,0,0,.12) !important;
	}
	.taskboard-task .list-card-footer {
	    border-top: 1px solid;
	    padding: 0 16px;
		height: 38px;
	}

	.taskboard-task .list-card-footer .list-card-footer-item:last-of-type {
	    margin-right: 0;
	}
	.taskboard-task .list-card-footer .list-card-footer-item {
	    margin-right: 12px;
	    color: rgba(0,0,0,.54);
	}
	.taskboard-task .list-card-footer .list-card-footer-item .value {
	    padding-left: 8px;
	}

	.taskboard-task .v-overlay__content {
		position: absolute;
		top: 8px;
		right: 4px;
	}
</style>